import { Router } from '@angular/router';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-success-modal',
  templateUrl: './success-modal.component.html',
  styleUrls: ['./success-modal.component.scss']
})
export class SuccessModalComponent implements OnInit {


  timer = 20;

  constructor(
    private dialog_ref: MatDialogRef<SuccessModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private router: Router
  ) { }

  ngOnInit(): void {
    console.log(this.data);
    let interval = setInterval(() => {
      this.timer--;
      if (0 >= this.timer) {
        // this.dialog_ref.close();
        clearInterval(interval);
      }
    }, 1000)
  }
  goToBase() {
    this.dialog_ref.close();
  }
  goToLogin() {
    if (this.data && this.data.url) {
      this.router.navigate([this.data.url]);
      this.dialog_ref.close();
    }

  }

}
